import React from "react";
import LocalImages from '../../static';
import { dateFormatter } from "src/shared/utils/src";
import { ACTIVITY_DETAIL_TYPE, DATE_FORMATS } from "src/shared/config/src";
import TextRenderer from "./TextRenderer";
import { SuccessStatusTag, WarningStatusTag, ErrorStatusTag } from "./statusTags";

type AccidentSheetCardProps = {
    content: string
    timestamp: string
    status: string
    notes: string
    type: string
}

const AccidentMedicineReportCardInternalDetails: React.FC<AccidentSheetCardProps> = ({ content, timestamp, status, notes, type }) => {

    const getIconSource = () => {
        if (type === ACTIVITY_DETAIL_TYPE.ACCIDENT)
            return LocalImages.accidentSheetCardIcon;
        else if (type === ACTIVITY_DETAIL_TYPE.MEDICINE)
            return LocalImages.medicineFormIcon;
        else
            return LocalImages.reportIcon;
    }

    const getHeaderName = () => {
        if (type === ACTIVITY_DETAIL_TYPE.ACCIDENT)
            return 'Accident Sheet';
        else if (type === ACTIVITY_DETAIL_TYPE.MEDICINE)
            return 'Medicine Form';
        else
            return 'Report';
    }

    const renderStatusTags = (status: string) => {
        if (!status) return;
        switch (status.toLowerCase()) {
            case 'completed':
                return <SuccessStatusTag statusString={status} />;
            case 'rejected':
                return <ErrorStatusTag statusString={status} />
            default:
                return <WarningStatusTag statusString={status} />
        }
    }

    return (
        <>
            <div className="d-flex align-items-center">
                <div className="section-with-img flex-1 pd-r-15">
                    <div className="section-img"><img src={getIconSource()}  alt="icon-source"/></div>
                    <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{ content ?? getHeaderName() }</div>
                </div>
                <div className="fs-12 text-gray-300">
                    { dateFormatter(timestamp, DATE_FORMATS.TIME_AMPM) || '' }
                </div>
            </div>
            <div className="mg-l-40">
                {
                    status ? 
                        renderStatusTags(status)
                    : null
                }
            </div>
            {
                notes ?
                <div className="mg-t-13 fs-12 text-black">
                    Notes: <TextRenderer text={ notes } />
                </div> : null
            }
        </>
    )
}

export default AccidentMedicineReportCardInternalDetails;